import axios from '@/service/interceptor';
import settings from './settings';

function getAssets() {
    const pm = new Promise((resolve) => {
        axios.get(`${settings.HOST_V2}/currencies`, { xDomain: true })
            .then((res) => {
                localStorage.setItem('assets', JSON.stringify(res.data));
                resolve(res);
            });
    });
    return pm;
}

export default {
    getAssets,
};



// WEBPACK FOOTER //
// ./src/utils/asset.js